import { ERRORS } from "../../../../../constants/errors";
import { LOCALE_EN_GB } from "../../../../../constants/constants";
import { getErrorMessage } from "../getErrorMessage";
import type { Validator } from "./types";

export const tel: Validator = ({
  name,
  answer,
  validation,
  locale = LOCALE_EN_GB,
  questionErrorMessage,
}) => {
  const ukPhoneRegex = /^(\+44|0044|44|0)\d{9,11}$/;
  // US phone regex matches (XXX) XXX-XXXX format from MaskedField
  const usPhoneRegex = /^\(\d{3}\)\s\d{3}-\d{4}$/;

  const strippedAnswer = answer.replace(/\s/g, "");
  const isUK = locale === LOCALE_EN_GB;

  const valid = isUK
    ? ukPhoneRegex.test(strippedAnswer)
    : usPhoneRegex.test(answer); // US format needs parentheses and hyphens

  return {
    id: name,
    valid,
    message: valid
      ? undefined
      : getErrorMessage({
          validationMessage: validation.message,
          questionErrorMessage,
          fallbackMessage: ERRORS.INVALID_TEL,
        }),
  };
};
